const AuthTransferShowcase = () => (
  <aside className="auth-showcase relative flex min-h-[350px] flex-col items-center justify-center overflow-hidden px-6 py-8 text-[#302521] sm:px-10 lg:min-h-[540px] lg:px-8 lg:py-10 xl:px-10">
    <div className="auth-showcase-orbit pointer-events-none absolute -right-24 -top-28 h-80 w-80 rounded-full border border-[#cdb8ce]/60" />
    <div className="auth-showcase-orbit auth-showcase-orbit-inner pointer-events-none absolute -right-12 -top-16 h-56 w-56 rounded-full border border-[#cdb8ce]/50" />
    <p className="relative z-10 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#882699]">
      How your transfer works
    </p>

    <div className="auth-journey relative mt-9 h-[195px] w-full max-w-[360px]">
      <svg
        className="absolute inset-0 h-full w-full"
        viewBox="0 0 440 225"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M78 120C135 13 305 13 362 120"
          stroke="#c5b6c7"
          strokeWidth="2"
          strokeDasharray="3 8"
        />
        <path
          className="auth-journey-arc"
          d="M78 120C135 13 305 13 362 120"
          stroke="#882699"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>

      <div className="auth-journey-node absolute bottom-[17px] left-[calc(18%-30px)] flex h-[60px] w-[60px] items-center justify-center rounded-full border border-[#d8cfc4] bg-[#fffdf9] text-[#882699]">
        <svg className="h-7 w-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true">
          <rect x="6" y="2.5" width="12" height="19" rx="2.5" />
          <path strokeLinecap="round" d="M10 18.5h4" />
        </svg>
      </div>
      <div className="auth-journey-node auth-journey-node-recipient absolute bottom-[17px] right-[calc(18%-30px)] flex h-[60px] w-[60px] items-center justify-center rounded-full border border-[#d8cfc4] bg-[#fffdf9] text-[#882699]">
        <svg className="h-7 w-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="m3 11 9-8 9 8M5 10v10h14V10M9 20v-6h6v6" />
        </svg>
      </div>

      <span className="absolute bottom-0 left-[18%] -translate-x-1/2 text-[11px] text-[#766b64]">
        You, in Canada
      </span>
      <span className="absolute bottom-0 right-[18%] translate-x-1/2 text-[11px] text-[#766b64]">
        Your recipient
      </span>

      <div className="auth-journey-badge absolute left-1/2 top-[48px] flex h-12 w-12 -translate-x-1/2 items-center justify-center rounded-full border border-[#cdb8ce] bg-[#f8eff9] text-[#882699]">
        <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
          <rect x="5" y="10" width="14" height="11" rx="2" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M8 10V7a4 4 0 1 1 8 0v3" />
        </svg>
      </div>
      <span className="absolute left-[24%] top-[54px] rounded-full border border-[#d8cfc4] bg-[#fffdf9] px-4 py-1 text-[10px] font-semibold text-[#302521]">
        100 CAD
      </span>
      <span className="absolute right-[10%] top-[54px] rounded-full bg-[#e2f1e6] px-4 py-1 text-[10px] font-semibold text-[#27613b]">
        1,050 NKF
      </span>
    </div>

    <div className="auth-stage-area relative mt-2 h-[115px] w-full max-w-[360px]">
      {[
        {
          title: "Enter an amount",
          description: "Pick the country and see the rate and fee first.",
          badge: "Rate 1 CAD ≈ 10.50 NKF · Fee 5 CAD",
        },
        {
          title: "Pay securely",
          description: "Your payment is protected with identity checks.",
          badge: "Payment protected",
        },
        {
          title: "Money on its way",
          description: "Follow your transfer while it travels.",
          badge: "On its way",
        },
        {
          title: "Delivered",
          description: "Your recipient receives 1,050 NKF.",
          badge: "Delivered",
        },
      ].map(({ title, description, badge }, index) => (
        <div className="auth-stage absolute inset-0" style={{ "--stage-index": index }} key={title}>
          <div className="mx-auto mb-3 w-fit rounded-full border border-[#d8cfc4] bg-[#fffdf9] px-4 py-1 text-center text-[10px] font-semibold text-[#514641]">
            {badge}
          </div>
          <h2 className="text-base font-semibold">{title}</h2>
          <p className="mt-1 text-xs leading-5 text-[#766b64]">{description}</p>
        </div>
      ))}
    </div>

    <div className="mt-4 flex w-full max-w-[360px] gap-2" aria-hidden="true">
      {[0, 1, 2, 3].map((step) => (
        <span className="auth-progress-segment h-1 flex-1 overflow-hidden rounded-full bg-[#d8cfc4]" style={{ "--stage-index": step }} key={step}>
          <span />
        </span>
      ))}
    </div>
  </aside>
);

export default AuthTransferShowcase;
